import React, { useRef, useState, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutContentHeader.css';

const AboutContentHeader = ({ platformName, subtitle, overview, headerImage, platformKey }) => {
  const imageContainerRef = useRef(null);
  const [orbitCenter, setOrbitCenter] = useState({ x: 0, y: 0 });

  useLayoutEffect(() => {
    const updateOrbitCenter = () => {
      if (imageContainerRef.current) {
        const rect = imageContainerRef.current.getBoundingClientRect();
        setOrbitCenter({
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2,
        });
      }
    };

    updateOrbitCenter();
    window.addEventListener('resize', updateOrbitCenter);
    
    // Also re-calculate after a short delay to handle late-loading elements
    const timeoutId = setTimeout(updateOrbitCenter, 100);

    return () => {
      window.removeEventListener('resize', updateOrbitCenter);
      clearTimeout(timeoutId);
    };
  }, [headerImage]); // Recalculate if the image changes

  return (
    <div className="about-content-header">
      <div className="about-content-header-nav">
        <Link to="/" className="about-content-header-back-btn">← Back to Home</Link>
      </div>
      
      <div className="about-content-header-main">
        <div className="about-content-header-content">
          <h3 className="about-content-header-title">{platformName}</h3>
          <p className="about-content-header-subtitle">
            {subtitle.split(' ').map((word, index) => {
              if (index === 0) {
                return <span key={index} className="regular-word">{word} </span>;
              } else if (index >= 1 && index <= 3) {
                if (index === 1) {
                  // Start of gradient span
                  const highlightedWords = subtitle.split(' ').slice(1, 4).join(' ');
                  return <span key="gradient-group" className="highlight-word">{highlightedWords}</span>;
                } else {
                  // Skip these words as they're already included in the gradient span
                  return null;
                }
              } else {
                return <span key={index} className="regular-word"> {word}{index < subtitle.split(' ').length - 1 && ' '}</span>;
              }
            })}
          </p>
          <div className="about-content-header-overview">
            {overview.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
        
        <div ref={imageContainerRef} className="about-content-header-image-container">
          {headerImage ? (
            <img src={headerImage} alt={`${platformName} platform visual`} className="about-content-header-image" />
          ) : (
            <div className="about-content-header-image-placeholder">
              <span>📷</span>
              <p>Image Not Available</p>
            </div>
          )}
        </div>
      </div>
      
      {/* Orbit Animation System */}
      <div 
        className="orbit-container"
        style={{
          top: `${orbitCenter.y}px`,
          left: `${orbitCenter.x}px`,
        }}
      >
        <div className="orbit-path orbit-path-1">
          <div className="orbit-element orbit-element-1"></div>
        </div>
        
        <div className="orbit-path orbit-path-2">
          <div className="orbit-element orbit-element-2"></div>
        </div>
        
        <div className="orbit-path orbit-path-3">
          <div className="orbit-element orbit-element-3"></div>
        </div>
        
        <div className="orbit-path orbit-path-4">
          <div className="orbit-element orbit-element-4"></div>
        </div>
        
        <div className="orbit-path orbit-path-5">
          <div className="orbit-element orbit-element-5"></div>
        </div>

        <div className="orbit-path orbit-path-6">
          <div className="orbit-element orbit-element-6"></div>
        </div>
      </div>
    </div>
  );
};

export default AboutContentHeader; 